import React, { useEffect, useState } from 'react';
import {
    ContentState,
    convertToRaw,
    EditorState,
    Modifier,
} from 'draft-js';

import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {parseToWord} from "../../../../constants";
import ArrayDropDownComponent from "@pages/components/ArrayDropDownComponent";
const parentObjectNames = ['customer', 'deal', 'dealer', 'vehicle'];
const customerObjectNames = ['customer'];

export default function EditorComponent({
                                            showShortCodes = true,
                                            editorStateInitial = null,
                                            onEditorStateChange,
                                            wrapperClassName = 'wrapperClassName',
                                            shortCodesObject = null,
                                            onlyCustomer = false,
                                        }) {
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
  const [selectedShortCodeMenu,setSelectedShortCodeMenu] = useState(null)

    const change = (state) => {
        setEditorState(state);
        const content = draftToHtml(convertToRaw(state.getCurrentContent()));
        onEditorStateChange(content);
    };

    useEffect(() => {
        if (editorStateInitial) {
            const contentBlock = htmlToDraft(editorStateInitial);
            if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                setEditorState(EditorState.createWithContent(contentState));
            }
        }
    }, [editorStateInitial]);

    const insertTextAtCursor = (text) => {
        const contentState = editorState.getCurrentContent();
        const selectionState = editorState.getSelection();

        const newContentState = Modifier.insertText(contentState, selectionState, text);
        const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');

        setEditorState(newEditorState);
        onEditorStateChange(draftToHtml(convertToRaw(newEditorState.getCurrentContent())));
    };
    return (
        <>
            {/* Custom Selects */}
            {showShortCodes && <div style={{marginBottom: 10}}>
                <ArrayDropDownComponent
                    items={onlyCustomer ? customerObjectNames : parentObjectNames}
                    defaultText={'Menu'}
                    onSelect={(e) => setSelectedShortCodeMenu(e)}
                />
                {
                    selectedShortCodeMenu &&
                    <ArrayDropDownComponent
                        items={shortCodesObject[selectedShortCodeMenu]}
                        defaultText={selectedShortCodeMenu}
                        onSelect={(e) => insertTextAtCursor(e)}
                    />
                }

            </div>}

            {/* Editor */}
            <Editor
                editorState={editorState}
                toolbarClassName="toolbarClassName"
                wrapperClassName={wrapperClassName}
                editorClassName="editorClassName"
                onEditorStateChange={change}
            />
        </>
    );
}
